// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__3lg1X","col":"ProductsDashboard_col__vqt-n","card":"ProductsDashboard_card__BQNyk"};